module.exports = __webpack_public_path__ + "assets/img/logo_footer.52b9d115.png";